export enum OutvioCode {
  DELETED_SHIPMENT = 'DELETED_SHIPMENT',
  BAD_ADDRESS = 'BA',
  CANCELLED = 'CAN',
  CREATED = 'CREA',
  DAMAGED = 'D',
  DELIVERED = 'DEL',
  DELIVERED_TO_PICKUP_POINT = 'DELPU',
  DELIVERED_TO_SHOP = 'DELSHOP',
  DESTROYED = 'DES',
  DELAYED = 'DLY',
  DELAYS = 'DLYS',
  EXTREME_DELAY = 'EDLY',
  CALCULATED_DELAY = 'ODLY',
  IN_TRANSIT_DELAYED = 'ITD',
  MISSING_DOCUMENTATION = 'DOC',
  HAND_OVER = 'HO',
  IMPORTANT_INCIDENTS = 'IMP',
  IN_TRANSIT = 'IT',
  LOST = 'L',
  NOT_AT_HOME = 'NAH',
  NOT_AT_HOME_2 = 'NAH2',
  NOT_AT_HOME_3 = 'NAH3',
  OUT_FOR_DELIVERY = 'OFD',
  OTHER_INCIDENTS = 'OTH',
  PARTIALLY_DELIVERED = 'PD',
  PICKED_UP = 'PU',
  REFUSED = 'REF',
  RETURN_TO_ORIGIN = 'RTO',
  SENT_TO_AGENCY = 'STA',
  STOLEN = 'T',
  RECEIVED = 'REC',
  PROCESSING = 'PRC',
}

export const INCIDENT_CODES = [
  OutvioCode.BAD_ADDRESS,
  OutvioCode.NOT_AT_HOME,
  OutvioCode.NOT_AT_HOME_2,
  OutvioCode.NOT_AT_HOME_3,
  OutvioCode.MISSING_DOCUMENTATION,
  OutvioCode.CANCELLED,
  OutvioCode.IMPORTANT_INCIDENTS,
  OutvioCode.OTHER_INCIDENTS,
  OutvioCode.LOST,
  OutvioCode.DAMAGED,
  OutvioCode.STOLEN,
  OutvioCode.DESTROYED,
  OutvioCode.RETURN_TO_ORIGIN,
  OutvioCode.REFUSED,
  OutvioCode.DELAYED,
  OutvioCode.DELAYS,
  OutvioCode.IN_TRANSIT_DELAYED,
  OutvioCode.CALCULATED_DELAY,
  OutvioCode.EXTREME_DELAY,
  OutvioCode.PARTIALLY_DELIVERED,
];

export const isIncidentCode = (code?: string | null): boolean =>
  !!code && INCIDENT_CODES.includes(code as OutvioCode);

const OUTVIO_CODES = Object.values(OutvioCode) as string[];

export const isOutvioCode = (value?: string | null): value is OutvioCode =>
  !!value && OUTVIO_CODES.includes(value);

type ShipmentWithLocation = { currentLocation?: { code?: string } | null };

type OrderWithCode = {
  inTransitStatus?: string | null;
  shipping?: { shipments?: { shipping?: (ShipmentWithLocation | string)[] } };
};

export const getOrderCode = (order?: OrderWithCode | null): OutvioCode | undefined => {
  const shipment = order?.shipping?.shipments?.shipping?.[0];
  const shipmentCode = typeof shipment === 'object' ? shipment?.currentLocation?.code : undefined;
  if (isOutvioCode(shipmentCode)) return shipmentCode;
  return isOutvioCode(order?.inTransitStatus) ? order?.inTransitStatus : undefined;
};
